import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const [menuItems, setMenuItems] = useState([
    {
      id: "widgets",
      label: "Dashboard",
      icon: "ri-home-4-line",
      link: "/dashboard",
      pkey: "Dashboard",
      parentId: "dashboard",
    },
    {
      id: "users",
      pkey: "Users",
      label: "User",
      link: "/users",
      icon: "ri-user-line",
      parentId: "users",
    },
    {
      id: "farmhouses",
      pkey: "Farmhouses",
      label: "Farmhouses",
      link: "/farmhouses",
      icon: "ri-home-line",
      parentId: "farmhouses",
    },
    {
      id: "bookings",
      pkey: "Bookings",
      label: "Bookings",
      link: "/bookings",
      icon: "ri-calendar-line",
      parentId: "bookings",
    },
    {
      id: "booking-sheet",
      pkey: "Booking Sheet",
      label: "Booking Sheet",
      link: "/booking-sheet",
      icon: "ri-calendar-todo-line",
      parentId: "bookings",
    },
    {
      id: "house-rules",
      pkey: "House Rules",
      label: "House Rules",
      link: "/house-rules",
      icon: "ri-home-line",
      parentId: "house-rules",
    },
    {
      id: "privacy-policy",
      pkey: "Privacy Policy",
      label: "Privacy Policy",
      link: "/privacy-policy",
      icon: "ri-shield-line",
      parentId: "privacy-policy",
    },
    {
      id: "terms-condition",
      pkey: "Terms & Conditions",
      label: "Terms & Conditions",
      link: "/terms-condition",
      icon: "ri-file-text-line",
      parentId: "terms-condition",
    },
    {
      id: "cancellation-policy",
      pkey: "Cancellation Policy",
      label: "Cancellation Policy",
      link: "/cancellation-policy",
      icon: "ri-close-circle-line",
      parentId: "cancellation-policy",
    },
    {
      id: "settings",
      pkey: "Settings",
      label: "Settings",
      link: "/settings",
      icon: "ri-settings-3-line",
      parentId: "settings",
    },
  ]);

  const dynamicmenuItems = menuItems;

  return <React.Fragment>{dynamicmenuItems}</React.Fragment>;
};

export default Navdata;
